import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';

export class GroupFormHelper {
    public static trimEmptySpaces(dynamicKeyValue: IDynamicKeyValue, defaultLanguage: string): IDynamicKeyValue {
        let trimmedDynamicKeyValue: IDynamicKeyValue = {};
        trimmedDynamicKeyValue[defaultLanguage] = dynamicKeyValue[defaultLanguage].trim();
        return trimmedDynamicKeyValue;
    }
}
